import type { Screen } from "./types"

import Profile1F from "assets/images/profile-1-f.png"
import Profile2F from "assets/images/profile-2-f.png"
import Profile3F from "assets/images/profile-3-f.png"
import Profile4F from "assets/images/profile-4-f.png"

import Profile1M from "assets/images/profile-1-m.png"
import Profile2M from "assets/images/profile-2-m.png"
import Profile3M from "assets/images/profile-3-m.png"
import Profile4M from "assets/images/profile-4-m.png"

export const SURVEY_CONFIG_CHAT2: Array<Screen[]> = [
  [
    {
      type: "chat",
      hideProgressBar: true,
      chatQuestions: [
        {
          label: "v3.message.intro.1",
          id: "intro_1",
          type: "empty",
        },
        {
          label: "v3.message.intro.2",
          id: "intro_2",
          type: "empty",
          isTyping: true,
        },
        {
          label: "v3.message.gender.1",
          id: "gender",
          type: "gender",
          options: [
            { label: "gender.f", gender: "f" },
            { label: "gender.m", gender: "m" },
          ],
        },
        {
          label: "v3.message.sexuality.1",
          id: "sexuality",
          type: "sexuality",
          optionsByGender: {
            m: [
              "v3.option.sexuality.h",
              "v3.option.sexuality.b",
              "v3.option.sexuality.g",
              "v3.option.sexuality.q",
              "v3.option.sexuality.a",
            ],
            f: [
              "v3.option.sexuality.h",
              "v3.option.sexuality.b",
              "v3.option.sexuality.l",
              "v3.option.sexuality.q",
              "v3.option.sexuality.a",
            ],
          },
        },
        {
          label: "v3.message.age.1",
          id: "age",
          type: "single",
          options: ["18-24", "25-29", "30-39", "40-49", "50+"],
        },
        {
          label: "v3.message.range.1",
          id: "range",
          type: "single",
          options: ["18-24", "25-29", "30-39", "40-49", "50+"],
        },
        {
          label: "v3.message.date.1",
          id: "date",
          type: "single",
          options: ["first_date.1", "first_date.2", "first_date.3"],
        },
        {
          label: "v3.message.languages.1",
          id: "languages",
          type: "single",
          options: [
            "languages.en",
            "languages.fr",
            "languages.es",
            "languages.ch",
            "languages.de",
            "languages.hi",
          ],
        },
        {
          label: "v3.message.relationships.1",
          id: "relationship",
          type: "single",
          options: [
            "open_relationship.1",
            "open_relationship.2",
            "open_relationship.3",
          ],
        },
        {
          label: "v3.message.zodiak.1",
          id: "zodiak",
          type: "zodiak",
        },
        {
          label: "v3.message.turnons.1",
          id: "turnons",
          type: "single",
          options: [
            "turnons.kisses",
            "turnons.biting",
            "turnons.dirtytalk",
            "turnons.edging",
            "turnons.scents",
            "turnons.footfetish",
          ],
        },
      ],
    },
    {
      type: "match-stub",
      text: "match_stub.match.text",
      bgColor: "#EDD4A6",
      hideProgressBar: true,
      values: {
        users: 77,
        compatibility: 46,
      },
      id: "screen_possible_match_1",
    },
    {
      type: "chat",
      hideProgressBar: true,
      chatQuestions: [
        {
          label: "v3.message.turnons2.1",
          id: "turnons2",
          type: "single",
          options: ["turnons2.1", "turnons2.2", "turnons2.3"],
        },
        {
          label: "v3.message.profile.1",
          id: "profile",
          type: "image",
          srcsByGender: {
            f: [Profile1F, Profile2F, Profile3F, Profile4F],
            m: [Profile1M, Profile2M, Profile3M, Profile4M],
          },
          options: ["common.yes", "common.no"],
        },
        {
          label: "v3.message.turnons3.1",
          id: "turnons3",
          type: "single",
          options: ["turnons3.1", "turnons3.2", "turnons3.3"],
        },
        {
          label: "v3.message.conversations.1",
          id: "conversations",
          type: "single",
          options: ["conversations.1", "conversations.2", "conversations.3"],
        },
      ],
    },
    {
      type: "match-stub",
      text: "match_stub.plain.text",
      bgColor: "#EDD4A6",
      hideProgressBar: true,
      id: "screen_matches_placeholder",
    },
    {
      type: "chat",
      hideProgressBar: true,
      chatQuestions: [
        {
          label: "v3.message.hair.1",
          id: "hair",
          type: "single",
          options: ["hair.1", "hair.2", "hair.3"],
        },
        {
          label: "v3.message.partner_qualities.1",
          id: "partner_qualities",
          type: "single",
          options: [
            "partner_qualities.1",
            "partner_qualities.2",
            "partner_qualities.3",
          ],
        },
        {
          label: "v3.message.dress_style.1",
          id: "dress_style",
          type: "single",
          options: ["dress_style.1", "dress_style.2", "dress_style.3"],
        },
        {
          label: "v3.message.travel.1",
          id: "travel",
          type: "single",
          options: ["travel.1", "travel.2"],
        },
        {
          label: "v3.message.lifestyle.1",
          id: "lifestyle",
          type: "single",
          options: [
            "lifestyle.1",
            "lifestyle.2",
            "lifestyle.3",
            "lifestyle.4",
            "lifestyle.5",
          ],
        },
        {
          label: "v3.message.turnons_bedroom.1",
          id: "lifestyle",
          type: "single",
          options: [
            "turnons_bedroom.1",
            "turnons_bedroom.2",
            "turnons_bedroom.3",
            "turnons_bedroom.4",
            "turnons_bedroom.5",
            "turnons_bedroom.6",
          ],
        },
      ],
    },
    {
      type: "match-stub",
      text: "match_stub.match.text",
      bgColor: "#EDD4A6",
      hideProgressBar: true,
      values: {
        users: 32,
        compatibility: 88,
      },
      id: "screen_possible_match_2",
    },
    {
      type: "auth",
      textColor: "#000000",
      hideProgressBar: true,
      showFacebook: true,
      logoColor: "transparent",
      action: "registration",
      id: "screen_registration",
    },
    {
      type: "paygate",
      paygateType: "paymentButtonsBottom",
      withEverflow: true,
      hideProgressBar: true,
      noMaxHeight: true,
      noMaxWidth: true,
      action: "checkout",
      id: "screen_paywall",
      bgColor: "#1A1717",
      bundles: {
        year: {
          us: {
            name: {
              paypal: "pure-web.year.paypal.us",
              cardpay: "pure-web.year.cardpay.us",
            },
            label: "paygate.subscription.year",
          },
          uk: {
            name: {
              paypal: "pure-web.year.paypal.uk",
              cardpay: "pure-web.year.cardpay.uk",
            },
            label: "paygate.subscription.year",
          },
          eu: {
            name: {
              paypal: "pure-web.year.paypal.eu",
              cardpay: "pure-web.year.cardpay.eu",
            },
            label: "paygate.subscription.year",
          },
          row: {
            name: {
              paypal: "pure-web.year.paypal.row",
              cardpay: "pure-web.year.cardpay.row",
            },
            label: "paygate.subscription.year",
          },
        },
        month: {
          us: {
            name: {
              paypal: "pure-web.monthly.paypal.us",
              cardpay: "pure-web.monthly.cardpay.us",
            },
            label: "paygate.subscription.month",
          },
          uk: {
            name: {
              paypal: "pure-web.monthly.paypal.uk",
              cardpay: "pure-web.monthly.cardpay.uk",
            },
            label: "paygate.subscription.month",
          },
          eu: {
            name: {
              paypal: "pure-web.monthly.paypal.eu",
              cardpay: "pure-web.monthly.cardpay.eu",
            },
            label: "paygate.subscription.month",
          },
          row: {
            name: {
              paypal: "pure-web.monthly.paypal.row",
              cardpay: "pure-web.monthly.cardpay.row",
            },
            label: "paygate.subscription.month",
          },
        },
        week: {
          us: {
            name: {
              paypal: "pure-web.weekly.paypal.us",
              cardpay: "pure-web.weekly.cardpay.us",
            },
            label: "paygate.subscription.week",
          },
          uk: {
            name: {
              paypal: "pure-web.weekly.paypal.uk",
              cardpay: "pure-web.weekly.cardpay.uk",
            },
            label: "paygate.subscription.week",
          },
          eu: {
            name: {
              paypal: "pure-web.weekly.paypal.eu",
              cardpay: "pure-web.weekly.cardpay.eu",
            },
            label: "paygate.subscription.week",
          },
          row: {
            name: {
              paypal: "pure-web.weekly.paypal.row",
              cardpay: "pure-web.weekly.cardpay.row",
            },
            label: "paygate.subscription.week",
          },
        },
      },
    },
    {
      type: "payment-success",
      hideProgressBar: true,
      action: "purchase_success",
      noMaxWidth: true,
    },
  ],
]
